import { render, staticRenderFns } from "./protocol-detail.vue?vue&type=template&id=6676a350&scoped=true&"
import script from "./protocol-detail.vue?vue&type=script&lang=js&"
export * from "./protocol-detail.vue?vue&type=script&lang=js&"
import style0 from "./protocol-detail.vue?vue&type=style&index=0&id=6676a350&lang=less&scoped=true&"
import style1 from "./protocol-detail.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6676a350",
  null
  
)

export default component.exports